import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import {
  AccessKey,
  User,
} from 'src/class';


type event_UpdateUser = {
  action: string;
  data: User;
  type: string;
  values: number[];
};

type T_Validation = {
  condition: string,
  message:   string
};


@Component({
  selector: 'app-avia-form-search-users',
  templateUrl: './avia-form-search-users.component.html',
  styleUrls: ['./avia-form-search-users.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AviaFormSearchUsersComponent),
      multi: true
    }
  ]
})
export class AviaFormSearchUsersComponent implements ControlValueAccessor {

  @Input() multi_select:  boolean        = true;
  @Input() org_id:        number | number[];
  @Input() prompt_string: String         = 'Add a new user';
  @Input() validation:    T_Validation[] = [];

  akey:          AccessKey = new AccessKey(true, true, true, true, true);
  disabled:      boolean   = false;
  loading:       boolean   = false;
  selected_list: User[]    = [];


  // Typeahead Search
  //focus$ = new Subject<string>();
  //click$ = new Subject<string>();
  //model: string;


  constructor() {};

  updateUsers($event: event_UpdateUser) {
    if ( !this.disabled ) {
      switch ($event.action) {
        case 'add':
          // prevent duplicates
          let is_in_selected: boolean = false;
          if ( this.selected_list.length > 0 ) {
            if ( this.selected_list.map(s => s.id).indexOf($event.data.id) >= 0 ) is_in_selected = true;
          }

          if ( !is_in_selected ) this.selected_list.push($event.data);
        break;

        case 'delete':
          if($event.data.id) {
            this.selected_list = this.selected_list.filter(item => {
              if (item.id !== $event.data.id) return item;
            })
          }
        break;
      }

      this.writeValue(this.selected_list);
      this.propagateChange(this.selected_list);
    }
  };


  // Control Value Accessor - These functions must be declared even if empty

  writeValue(value: any) {
    this.selected_list = (value && value.length > -1) ? value : [];
  };

  propagateChange = (_: any) => {};
  registerOnChange(fn) {
    this.propagateChange = fn;
  };

  onTouched: any = () => {};
  registerOnTouched(fn) {
    this.onTouched = fn;
  };

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  };

}
